import React, { useContext} from 'react'
import {UsuarioContext} from 'config/context/UsuarioProvider'
// *** @material-ui/core components
import { makeStyles }   from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox         from "@material-ui/core/Checkbox";
import Check            from "@material-ui/icons/Check";

// *** Estilos
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";


const useStyles = makeStyles(basicsStyle);
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
export default function SeleccionDatosFacturacion() {
  const classes = useStyles()
  const {usuario, setusuario} = useContext(UsuarioContext)
  function onchange(status)
  {
    setusuario({...usuario, selectedEnabledEmpresa:status})
  }
  return (
    <div>
        <div className={classes.title} style={{ textAlign: "center",marginTop: "0px",marginBottom: "0px"}}>
          <h3 style={{fontWeight: "400"}}>Datos de facturación</h3>
        </div>
        <div  className={ classes.checkboxAndRadio +  " " +  classes.checkboxAndRadioHorizontal } >
          <FormControlLabel
            control={
              <Checkbox
                tabIndex={-1}
                onClick={(e) => onchange(false)} 
                checked={usuario.selectedEnabledEmpresa ?  false : true}
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{checked: classes.checked, root: classes.checkRoot}}
                                
                 /> 
            }
            classes={{ label: classes.label.useStyles, root: classes.labelRoot, label:classes.label}}           
            //label="Los mismos datos ingresados"
            label= "Emitir Boleta Electrónica con los datos ingresados anteriormente"
          />
        </div>
        <div  className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
          <FormControlLabel
            control={
              <Checkbox
                tabIndex={10}                
                onClick={(e) => onchange(true)}       
                checked={usuario.selectedEnabledEmpresa}               
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{checked: classes.checked,root: classes.checkRoot}}
                
              />
            }
            classes={{label:classes.label.useStyles, root: classes.labelRoot, label:classes.label}}
            
            //label="Ingresaré los datos de mi empresa"
            //label: classes.label.useStyles,
            label="Emitir Factura Electrónica con los datos que ingresaré en el siguiente paso"
          />
     </div>
              
    </div>
  )
}
